import { Button, Container, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Review from "src/components/Review";
import { reviews } from "src/constants/reviews";
import { useProduct } from "src/context/ProductProvider";

interface Props {
  onNavigate: () => void;
}

const EDReviews = ({ onNavigate }: Props) => {
  const { t } = useTranslation();
  const page = "ed-reviews";
  const slug = useProduct((p) => p.slug);

  const filteredReviews = useMemo(
    () => reviews.filter((r) => r.product?.includes(slug) && r.page === page),
    [slug]
  );

  return (
    <Container maxWidth="sm">
      <Stack gap={3}>
        <Typography variant="h4" fontWeight={600}>
          {t(
            `${page}.title`,
            "Millions deal with ED at HolaVida, getting help is simple, fast, and effective"
          )}
        </Typography>
        {filteredReviews.map((review) => (
          <Review key={review.name} review={review} onNext={onNavigate} />
        ))}
        <Button loading={false} onClick={onNavigate}>
          {t("welcome.ed-ot.button")}
        </Button>
      </Stack>
    </Container>
  );
};

export default EDReviews;
